// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2JSGQ","col":"styles_col__3ue4M"};